import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import YouTube from "react-youtube";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import ReactPlayer from "react-player";
import "./styles.css";

// import  courseData  from "../assets2/courseData/allcourses.json"
import Modal from "react-modal";

Modal.setAppElement("#root");

let page="1"
let dresstype="all"
const Products = () => {
  const [showModal, setShowModal] = useState(false);
  const [urlOfFreeYTVideoToShowInModal, setUrlOfFreeYTVideoToShowInModal] =
    useState("");
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState(data);
  const [loading, setLoading] = useState(false);
    const [ isOnMobile, setIsOnMobile ] = useState(false)
  let componentMounted = true;

  const dispatch = useDispatch();

  const addProduct = (product) => {
    dispatch(addCart(product));
  };

  const getProducts = async () => {
    setLoading(true);
    // let axiosres = await axios.get("/jsonfiles/allcourses.json");
    // let axiosres = await axios.get("/jsonfiles/allcourses.json", {
    let axiosres = await axios.get("/jsonfiles/allcourses"+page+".json"+`?t=${Date.now()}`, {
      // cache busting
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
    }
    });
    let courseData = axiosres.data;

    if (componentMounted) {
      setData(courseData);
      setFilter(courseData);

      setLoading(false);
    }

    return () => {
      componentMounted = false;
    };
  };

  useEffect(() => {


    getProducts("1");
    if(window.innerWidth < 750) {
      setIsOnMobile(true)
    }
  }, []);

  const Loading = () => {
    return (
      <>
        <div className="col-12 py-5 text-center">
          <Skeleton height={40} width={560} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
      </>
    );
  };

  const filterProduct = (cat) => {
    const updatedList = data.filter((item) => item.category === cat);
    setFilter(updatedList);
  };

  const ShowProducts = () => {
    return (
      <>
        <div className="buttons text-center py-2">
          <button
            className="btn btn-outline-dark btn-sm m-2"
            onClick={() => {
              dresstype="all"
              setFilter(data)}}
          >
            ALL
          </button>
          <button
            className="btn btn-outline-dark btn-sm m-2"
            onClick={() => {
              dresstype="saree"
              filterProduct("saree")}}
          >
            SAREE
          </button>
          <button
            className="btn btn-outline-dark btn-sm m-2"
            onClick={() => {
              dresstype="lehnga"
              filterProduct("lehnga")}}
          >
            LEHNGA
          </button>
          {/* <button
            className="btn btn-outline-dark btn-sm m-2"
            onClick={() => filterProduct("casuals")}
          >
            CASUALS
          </button> */}
          {/* <button
            className="btn btn-outline-dark btn-sm m-2"
            onClick={() => filterProduct("lingerie")}
          >
            LINGERIE & NIGHTWEAR
          </button> */}
        </div>


        <div id="justForScroll">
        </div>

        {filter.map((product) => {
          return (
            <div
              id={product.id}
              key={product.id}
              className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4"
            >
              <div className="card text-center h-100" key={product.id} >
                <img
                  className="card-img-top p-3"
                  src={product.image}
                  alt="Card"
                  // height={300}
                />
                <div className="card-body">
                  <h5 className="card-title" >
                    {product.title} <br />
                    Price: ₹ {product.price} <br />
                    {/* {product.title.substring(0, 12)}... */}
                  </h5>
                  <p className="card-text">
                    {/* {product.description.substring(0, 180)}... */}
                  </p>
                </div>
                <ul className="list-group list-group-flush" >
                  {product.price == 0 || product.price == "0" ? (
                    <li className="list-group-item lead">
                      Course coming soon कोर्स जल्द ही आ रहा है...{" "}
                    </li>
                  ) : (
                    <></>
                    // <li className="list-group-item lead"
                    
                    // >
                    //   ₹ {product.price} <br />
                    // </li>
                  )}
                  {/* <li className="list-group-item">Dapibus ac facilisis in</li>
                    <li className="list-group-item">Vestibulum at eros</li> */}
                </ul>

                {product.price == 0 || product.price == "0" ? (
                  <></>
                ) : (
                  <div className="card-body">
                    <Link
                      to={"/product/" +page+"/"+product.id}
                      className="btn btn-dark m-1"
                    >
                      VIEW DETAILS & BUY
                    </Link>
                    <button
                      className="btn btn-dark m-1"
                      onClick={() => {
                        // toast.success("click CLOSE to close the video");
                        setShowModal(true);
                        setUrlOfFreeYTVideoToShowInModal(
                          product.freeSampleYTVideo
                        );
                        // addProduct(product);
                      }}
                    >
                      PREVIEW
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="container my-1 py-3">
        <div className="row">
          <div className="col-12">
            <h2 className="display-6 text-center">25% OFF - CASH ON DELIVERY</h2>
            <div className="courses-heading">
              <h4 className="display-10 text-center">
                TRENDING WOMEN'S CLOTHING WITH A GLAMOROUS TOUCH
              </h4>
              {/* <a href="#samplecerti">
              <button>VIEW SAMPLE CERTIFICATE</button>
              </a> */}
            </div>
            <hr />
          </div>
        </div>
        <div className="row justify-content-center">
          {loading ? <Loading /> : <ShowProducts />}
        </div>
        <Modal
          isOpen={showModal}
          // onRequestClose={true}
          style={{
            overlay: {
              zIndex: 99020,
              // width: "84%",
              // height: "92%",
              // marginLeft: "8%",
              // marginTop: "0.5%",
              width: isOnMobile ? window.innerHeight * 0.84 : window.innerWidth * 0.84,
              height: isOnMobile ? window.innerWidth * 0.92 : window.innerHeight * 0.92,
              marginLeft: isOnMobile ? window.innerHeight * -0.15 : "8%",
              marginTop: isOnMobile ? window.innerWidth * 0.44 : "0.5%",
              transform: isOnMobile ? 'rotate(90deg)' : 'rotate(0deg)',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // backgroundColor: '#B3BFCD'
              // backgroundColor: "rgba(54, 72, 93, 0.90)",
              backgroundColor: "rgba(50, 50, 50, 0.90)",
              borderRadius: 25
            },
            content: {
              // backgroundColor: '#36485D'
              backgroundColor: "rgba(54, 72, 93, 0.4)",
            },
          }}
        >
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              height: "100%",
              // backgroundColor: "green",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <p style={{ color: "white", margin: 2 }}>
                PRODUCT PREVIEW
              </p>
              <p
                onClick={() => setShowModal(false)}
                style={{ color: "white", margin: 2, fontWeight: "bold" }}
              >
                CLOSE X
              </p>
            </div>
            {/* <YouTube
              videoId={urlOfFreeYTVideoToShowInModal}
              style={{ width: "100%", height: "100%" }}
              opts={{
                width: "100%",
                height: "100%",
                playerVars: { modestbranding: true, autoplay: 1 },
              }}
            /> */}
            <ReactPlayer
            width={"100%"}
            height={"100%"}
            // height={"93%"}
            // onEnded={() => videoEnded_updateCloud()}
            // muted={false}
            playing={true}
            loop={true}
            pip={false}
            volume={1}
            autoplay={true}
            vimeoConfig={{ iframeParams: { fullscreen: 0 } }}
            controls={true}
            // disabled full screen coz only then can overlay email address of the student
            config={{
              file: {
                attributes: {
                  onContextMenu: (e) => e.preventDefault(),
                  controlsList: "nodownload",
                },
              },
            }}
            url={urlOfFreeYTVideoToShowInModal}
          />
          </div>
        </Modal>
        <div  style={{display: 'flex', justifyContent: 'center' }}>
          <h5>Page: </h5>
          <h5 onClick={() => {  page="1";
                                getProducts()
                                const targetElement = document.getElementById('justForScroll');
                                targetElement.scrollIntoView({ behavior: 'smooth' });
                              }
                                } style={{ marginLeft: 15, marginRight: 15 }}>1</h5>
          <h5 onClick={() => {  page="2";
                                getProducts()
                                // window.scrollTo(0, 0)
                                const targetElement = document.getElementById('justForScroll');
                                targetElement.scrollIntoView({ behavior: 'smooth' });
                              }
                                } style={{ marginLeft: 15, marginRight: 15 }}>2</h5>
          <h5 onClick={() => {  page="3";
                                // getProducts()
                                // const targetElement = document.getElementById('justForScroll');
                                // targetElement.scrollIntoView({ behavior: 'smooth' });
                              }
                                } style={{ marginLeft: 15, marginRight: 15 }}>3</h5>
          <h5 onClick={() => {  page="4";
                                // getProducts()
                                // const targetElement = document.getElementById('justForScroll');
                                // targetElement.scrollIntoView({ behavior: 'smooth' });
                              }
                                } style={{ marginLeft: 15, marginRight: 15 }}>4</h5>
        </div>
      </div>
    </>
  );
};

export default Products;
